import React from "react";
import { useDispatch } from "react-redux";
import { View, Image, Text, Picker, ActivityIndicator } from "react-native";
import Icon from "react-native-vector-icons/FontAwesome";

import { PHONE_MAX_LENGTH } from "consts";
import { FullscreenInput, TextInput } from "components";
import { useContactNumberResponse } from "screens/question/hooks";
import Countries, { CountriesList } from "assets/countries";

import { styles } from "./styles";
import { useEffect } from "react";
import { setIPBasedCountryCode } from "state/modules/customer";

export const BaseContactNumberQuestion = ({ question }) => {
  const {
    value,
    hasError,
    countryCode,
    placeholder,
    onChange,
    validateCellphone,
    updateDialCode,
  } = useContactNumberResponse(question);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setIPBasedCountryCode());
  }, [dispatch]);
  return (
    <View style={styles.container}>
      <View style={styles.country}>
        {countryCode == "EMPTY" ? (
          <ActivityIndicator size="large" color="gray" />
        ) : (
          <>
            <Image
              style={styles.flag}
              resizeMode="contain"
              source={Countries[countryCode].flag}
            />
            <Text style={styles.dialCode}>
              +{Countries[countryCode].dialCode}
            </Text>
            <Icon
              name="caret-down"
              style={styles.caret}
              color={styles._caret?.color}
            />
            <Picker
              mode="dialog"
              style={styles.picker}
              selectedValue={countryCode}
              itemStyle={styles.pickerItem}
              onValueChange={dialCode => updateDialCode(dialCode, value)}
            >
              {CountriesList.map(country => (
                <Picker.Item
                  label={country.name}
                  key={country.countryCode}
                  value={country.countryCode}
                />
              ))}
            </Picker>
          </>
        )}
      </View>
      <TextInput
        value={value}
        onChangeText={onChange}
        keyboardType="phone-pad"
        style={styles.textField}
        placeholder={placeholder}
        maxLength={PHONE_MAX_LENGTH}
        onBlur={() => validateCellphone(value)}
        placeholderTextColor={styles._placeholder?.color}
      />
      <View
        style={[
          styles.icon,
          hasError === undefined
            ? {}
            : hasError
            ? styles.invalid
            : styles.valid,
        ]}
      >
        {hasError !== undefined && (
          <Icon name={hasError ? "times" : "check"} size={27} color="white" />
        )}
      </View>
    </View>
  );
};

export const ContactNumberQuestion = props => (
  <FullscreenInput component={BaseContactNumberQuestion} {...props} />
);
